import React from 'react';

/**
 * AdvantagesSection Component
 * 
 * Displays "Why Choose Code-E?" section with feature cards.
 * 
 * Exact styles from landing.css:
 * - Grid: repeat(auto-fit, minmax(350px, 1fr))
 * - Feature card padding: 1.5rem (24px)
 * - Border radius: 16px
 * - Border: 1px solid rgba(255, 255, 255, 0.1)
 * - Background: rgba(255, 255, 255, 0.03) with backdrop blur 15px
 */
const AdvantagesSection = () => {
  const advantages = [
    {
      id: 1,
      title: 'Tax Management',
      description: 'All-in-one system with financial statements and global regulations.',
    },
    {
      id: 2,
      title: 'Accuracy & Privacy',
      description: 'GDPR integrated. Run LAWNANCE on your own devices for maximum security.',
    },
    {
      id: 3,
      title: 'Secure Integration',
      description: 'Access all files in one app, integrated with your financial status.',
    },
    {
      id: 4,
      title: 'Multinational Law',
      description: 'Easily access other nations\' laws within a single platform.',
    },
  ];

  return (
    <section id="advantages" className="section py-section-mobile md:py-section-tablet lg:py-section-desktop px-4 md:px-6 lg:px-8 max-w-[1200px] mx-auto relative z-10">
      <h2 className="section-title text-center text-mobile-section-title md:text-2xl lg:text-section-title font-medium mb-6 md:mb-10 lg:mb-12 text-text-primary leading-tight md:leading-normal">
        Why <span className="lawnance-brand">LAWNANCE</span>?
      </h2>

      {/* Advantages Grid - MOBILE: Mobile-first spacing */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 lg:gap-8">
        {advantages.map((advantage) => (
          <div
            key={advantage.id}
            className="feature-card p-4 md:p-6 rounded-feature-card border border-white/10 transition-all duration-300 shadow-feature-card hover:-translate-y-1 hover:shadow-feature-card-hover hover:border-white/15"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              backdropFilter: 'blur(15px)',
              WebkitBackdropFilter: 'blur(15px)',
            }}
          >
            <h4 className="text-lg md:text-xl lg:text-info-block-title mb-2 text-text-primary">
              {advantage.title}
            </h4>
            <p className="text-text-secondary text-sm md:text-base lg:text-[0.9rem]">
              {advantage.description.includes('LAWNANCE') 
                ? advantage.description.split('LAWNANCE').map((part, index, array) => 
                    index === array.length - 1 
                      ? part 
                      : <React.Fragment key={index}>{part}<span className="lawnance-brand">LAWNANCE</span></React.Fragment>
                  )
                : advantage.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdvantagesSection;

